var _style, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBbsLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 366.4 122.4",
    style: {
      enableBackground: "new 0 0 366.4 122.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#798F9C;}\n\t.st1{fill:#ADC858;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "103.4,88.7 98.9,88.7 98.9,117.8 125.5,117.8 125.5,113.7 103.4,113.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "149.4,104.8 167.4,104.8 167.4,100.6 149.4,100.6 149.4,92.9 170.9,92.9 170.9,88.7 144.9,88.7  144.9,117.8 171.4,117.8 171.4,113.7 149.4,113.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "195.3,104.8 213.3,104.8 213.3,100.6 195.3,100.6 195.3,92.9 216.9,92.9 216.9,88.7 190.8,88.7  190.8,117.8 217.3,117.8 217.3,113.7 195.3,113.7  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M256.8,105.3c0.6-0.1,1.2-0.2,1.9-0.4c1.1-0.3,2.1-0.7,3-1.3c1-0.6,1.8-1.5,2.4-2.5c0.7-1.1,1-2.4,1-4 c0-1.8-0.4-3.3-1.2-4.4c-0.8-1.1-1.8-2-2.9-2.5c-1.1-0.6-2.4-1-3.8-1.1c-1.3-0.2-2.5-0.3-3.7-0.3h-16.7v29.1h4.5v-12.4h10.1l9,12.4 h5.6L256.8,105.3z M258.6,100.5c-0.7,0.3-1.5,0.5-2.5,0.6c-1,0.1-2.1,0.2-3.3,0.2h-11.4v-8.4h11.4c1.2,0,2.3,0.1,3.3,0.2 c1,0.1,1.8,0.3,2.5,0.6c0.7,0.3,1.2,0.7,1.6,1.3c0.4,0.5,0.5,1.2,0.5,2.1c0,0.9-0.2,1.6-0.6,2.2 C259.8,99.8,259.2,100.2,258.6,100.5z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M208.9,19.3h21.7h33.9v-14h-55.6c-9,0-16.7,5.9-19.3,14H208.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M249.7,31.9h-40.9c-16.7,0-20.3-6.3-20.3-6.3c0,11.2,9.1,20.3,20.3,20.3h40.9c3.5,0,6.3,2.8,6.3,6.3 s-2.8,6.3-6.3,6.3h-58.4v14h58.4c11.2,0,20.3-9.1,20.3-20.3C270,41,260.9,31.9,249.7,31.9z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M293.9,52.2c0-3.5,2.8-6.3,6.3-6.3l37.9,0c11.2,0,20.3-9.1,20.3-20.3c0-11.2-9.1-20.3-20.3-20.3h-40.2h-14.2 c0,0,3.6,14,20.3,14h34.1c3.5,0,6.3,2.8,6.3,6.3s-2.8,6.3-6.3,6.3l-37.9,0c-11.2,0-20.3,9.1-20.3,20.3v20.3h77.7v-14h-63.7V52.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M171.7,38.1c2.7-3.4,4.3-7.8,4.3-12.5c0-11.2-9.1-20.3-20.3-20.3H98.6v14h57.2c3.5,0,6.3,2.8,6.3,6.3 s-2.8,6.3-6.3,6.3h-25.5H126v14h4.3h25.5h1.4c3.5,0,6.3,2.8,6.3,6.3s-2.8,6.3-6.3,6.3h-44.6v-5.7h0V35.5v-9.8c0,0-14,2.5-14,14.1 v11.6h0v21.2h58.6c11.2,0,20.3-9.1,20.3-20.3C177.5,46.7,175.3,41.7,171.7,38.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M79.7,38.1c2.7-3.4,4.3-7.8,4.3-12.5c0-11.2-9.1-20.3-20.3-20.3H6.6v14h57.2c3.5,0,6.3,2.8,6.3,6.3 s-2.8,6.3-6.3,6.3H38.2H34v14h4.3h25.5h1.4c3.5,0,6.3,2.8,6.3,6.3s-2.8,6.3-6.3,6.3H20.6v-5.7h0V35.5v-9.8c0,0-14,2.5-14,14.1v11.6 h0v21.2h58.6c11.2,0,20.3-9.1,20.3-20.3C85.5,46.7,83.3,41.7,79.7,38.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBbsLogo);
export default __webpack_public_path__ + "static/media/BBSLogo.bee1c6d67b381879ee58f858b7da7d07.svg";
export { ForwardRef as ReactComponent };